import { Toaster as Sonner } from 'sonner';

export function Toaster(props: React.ComponentProps<typeof Sonner>) {
  return (
    <Sonner
      position="top-right"
      richColors
      // ARIA: Sonner sets aria-live="polite" on the region by default; this
      // is the polish bar for screen-reader announcements.
      toastOptions={{
        classNames: {
          toast: 'font-body',
          title: 'font-display',
        },
      }}
      {...props}
    />
  );
}

export { toast } from 'sonner';
